import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../config/Common";
import {
  handleError,
} from "../../Common/Alerts/errorhandling.action";
import { setShowError} from "../../Common/Alerts/alertsSlice";
import { getData } from "../../../../services/apiEndpoints";
import { getAY } from "../../../../Utils/academivYear";
import { getUserRole } from "../../../../Utils/getRoles";

// Fetch Admin Dashboard Data
export const fetchAdminDashboardData = createAsyncThunk(
  "adminDashboard/fetchAdminDashboardData",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const response = await getData(`/${getRole}/dashboard?say=${say}`);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Fetch Attendance Data
export const fetchAttendanceData = createAsyncThunk(
  "adminDashboard/fetchAttendanceData",
  async ({ month, year }, { rejectWithValue, getState, dispatch }) => {
    try {
     
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const response = await getData(
        `/${getRole}/dashboard/attendance?say=${say}`,
        {
          month,
          year,
        }
      );
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Fetch Earnings Data
export const fetchEarningsData = createAsyncThunk(
  "adminDashboard/fetchEarningsData",
  async (
    { month, year, includeUnpaidExpenses },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
    
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const response = await getData(
        `/${getRole}/dashboard/earnings?say=${say}`,
        {
          month,
          year,
          includeUnpaidExpenses,
        }
      );
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Fetch Notices
export const fetchNotices = createAsyncThunk(
  "adminDashboard/fetchNotices",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
     
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const response = await getData(
        `${baseUrl}/${getRole}/dashboard/notices?say=${say}`
      );
      return response?.notices;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);


// Fetch Filtered Events
export const fetchFilteredEvents = createAsyncThunk(
  "adminDashboard/fetchFilteredEvents",
  async ({ month, year }, { rejectWithValue, dispatch, getState }) => {
    try {
     
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const response = await getData(
        `/${getRole}/dashboard/events?say=${say}`,

        { month, year }
      );
      return response?.data;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Fetch Filtered Issue Books
export const fetchFilteredIssueBooks = createAsyncThunk(
  "adminDashboard/fetchFilteredIssueBooks",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
    
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));

      const response = await getData(
        `${baseUrl}/${getRole}/all/book?say=${say}`
      );
      return response?.books;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);
